import { render, staticRenderFns } from "./ModalCadastroSubEtapaResumoMeta.vue?vue&type=template&id=34febd7f&"
import script from "./ModalCadastroSubEtapaResumoMeta.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroSubEtapaResumoMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports